
































































































import Vue, { PropType } from "vue";

export interface AdministratorHamburgerMenuProps {
  baseUrl: string;
  lang: string;
  volumeLicenseId: string;
  volumeLicenseName: string;
}

export interface AdministratorHamburgerMenuData {
  isShowMenu: boolean;
  volumeLicenseBaseUrl: string;
}

export default Vue.extend({
  name: "vc-administrator-hamburger-menu",
  props: {
    baseUrl: {
      type: String as PropType<AdministratorHamburgerMenuProps["baseUrl"]>,
      default: "",
    },
    lang: {
      type: Object as PropType<AdministratorHamburgerMenuProps["lang"]>,
      default: () => {},
    },
    volumeLicenseId: {
      type: String as PropType<
        AdministratorHamburgerMenuProps["volumeLicenseId"]
      >,
      default: 0,
    },
    volumeLicenseName: {
      type: String as PropType<
        AdministratorHamburgerMenuProps["volumeLicenseName"]
      >,
      default: "",
    },
  },
  data(): AdministratorHamburgerMenuData {
    return {
      isShowMenu: false,
      volumeLicenseBaseUrl:
        this.baseUrl + "/volume-licenses/" + this.volumeLicenseId,
    };
  },
  methods: {
    // メニュー要素の内側: false, 外側: true
    isMenuOutSide(element: HTMLElement): boolean {
      const iconElement = document.querySelector("[data-icon]") as HTMLElement;
      const menuElement = document.querySelector(
        "[data-avatar-menu]"
      ) as HTMLElement;

      return !menuElement.contains(element) || iconElement.contains(element);
    },
    touchMenuButton() {
      this.isShowMenu = !this.isShowMenu;
      document.body.removeEventListener("click", this.onClickedBody);
      document.body.removeEventListener("touchstart", this.onClickedBody);
    },
    onClickedBody(event: MouseEvent | TouchEvent) {
      if (this.isMenuOutSide(event.target as HTMLElement)) {
        this.isShowMenu = false;
        document.body.removeEventListener("click", this.onClickedBody);
        document.body.removeEventListener("touchstart", this.onClickedBody);
      }
    },
  },
  watch: {
    isShowMenu() {
      if (this.isShowMenu) {
        setTimeout(() => {
          document.body.addEventListener("click", this.onClickedBody);
          document.body.addEventListener("touchstart", this.onClickedBody);
        }, 100);
      }
    },
  },
});
